<div class="screen">

  <!-- ── Logo + Greeting ── -->
  <div class="header-body">
    <img class="header-logo" src="assets/logo.png" alt="Logo laboratoire"
      [style.transform]="'scale(' + logoScale() + ')'" />
    <p class="app-greeting">{{ 'mobileSimulator.dashboard.greeting' | translate }}</p>
  </div>

  <!-- ── Hero Slider ── -->
  @let site = activeSites()[currentSlide()];
  <div class="hero-slider">

    <div class="slide-viewport"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (mouseleave)="onMouseLeave()">

      <!-- Card sortante -->
      @if (isAnimating() && exitSlideIdx() !== null) {
        @let ex = activeSites()[exitSlideIdx()!];
        <div class="slide-card slide-card--exit"
          [class.exit-to-left]="animDir() === 'left'"
          [class.exit-to-right]="animDir() === 'right'"
          [attr.data-status]="ex.statut">
          <div class="slide-hero" [attr.data-status]="ex.statut">
            <div class="slide-name-row">
              <span class="slide-dot" [attr.data-status]="ex.statut"></span>
              <span class="slide-name">{{ ex.nom }}</span>
              <span class="slide-badge">{{ ex.tensionLabel }}</span>
            </div>
            @if (ex.statut !== 'ferme') {
              <div class="slide-count-row">
                <span class="slide-count">{{ ex.presenceEstimee }}</span>
                <span class="slide-count-lbl">{{ 'mobileSimulator.dashboard.peopleOnSite' | translate }}</span>
              </div>
            }
          </div>
          <div class="slide-body">
            @if (ex.statut !== 'ferme') {
              <div class="slide-chips">
                @for (a of ex.alertes; track a.text) {
                  <span class="slide-chip" [attr.data-type]="a.type">{{ a.text }}</span>
                }
              </div>
            } @else { <p class="slide-ferme">{{ 'mobileSimulator.dashboard.noActivity' | translate }}</p> }
          </div>
        </div>
      }

      <!-- Card entrante -->
      <div class="slide-card"
        [class.enter-from-right]="isAnimating() && animDir() === 'left'"
        [class.enter-from-left]="isAnimating() && animDir() === 'right'"
        [attr.data-status]="site.statut"
        (click)="onCardClick(site)">
        <div class="slide-hero" [attr.data-status]="site.statut">
          <div class="slide-name-row">
            <span class="slide-dot" [attr.data-status]="site.statut"></span>
            <span class="slide-name">{{ site.nom }}</span>
            <span class="slide-badge">{{ site.tensionLabel }}</span>
          </div>
          @if (site.statut !== 'ferme') {
            <div class="slide-count-row">
              <span class="slide-count">{{ site.presenceEstimee }}</span>
              <span class="slide-count-lbl">{{ 'mobileSimulator.dashboard.peopleOnSite' | translate }}</span>
            </div>
          }
        </div>
        <div class="slide-body">
          @if (site.statut !== 'ferme') {
            <div class="slide-chips">
              @for (a of site.alertes; track a.text) {
                <span class="slide-chip" [attr.data-type]="a.type">{{ a.text }}</span>
              }
            </div>
            <div class="slide-timeline">
              @for (slot of getTimelineSlots(); track slot; let i = $index) {
                <div class="tl-col">
                  <span class="tl-dot" [style.background]="tlColor(site.timeline[i])"></span>
                  <span class="tl-time">{{ slot }}</span>
                </div>
              }
            </div>
          } @else { <p class="slide-ferme">Aucune activité</p> }
        </div>
      </div>

      <!-- Flèches -->
      <button class="hero-arrow hero-arrow--prev" (click)="prevSlide()">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#513E9B"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
      </button>
      <button class="hero-arrow hero-arrow--next" (click)="nextSlide()">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#513E9B"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
      </button>

    </div>

    <!-- Dots -->
    <div class="hero-dots">
      @for (s of activeSites(); track $index; let i = $index) {
        <span class="hero-dot" [class.hero-dot--active]="i === currentSlide()"></span>
      }
    </div>

  </div>

  <!-- {{ 'mobileSimulator.common.tousVoir' | translate }} -->
  <div class="link-row">
    <button class="link-btn" (click)="openList.emit()">{{ 'mobileSimulator.common.tousVoir' | translate }}</button>
  </div>

  <!-- ── Bannière large ── -->
  <div class="banner-card">
    <div class="banner-overlay">
      <span class="banner-title">{{ 'mobileSimulator.dashboard.bannerTitle' | translate }}</span>
      <span class="banner-sub">{{ 'mobileSimulator.dashboard.bannerSub' | translate: { count: activeSites().length } }}</span>
    </div>
    <div class="banner-visual">
      <svg width="52" height="52" viewBox="0 0 24 24" fill="rgba(255,255,255,0.35)">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    </div>
  </div>

  <!-- ── Grille 2 tuiles ── -->
  <div class="grid-2">
    <div class="grid-tile">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="#513E9B">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
      <span>{{ 'mobileSimulator.dashboard.tileAlertes' | translate }}</span>
    </div>
    <div class="grid-tile">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="#513E9B">
        <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
      </svg>
      <span>{{ 'mobileSimulator.dashboard.tilePlanning' | translate }}</span>
    </div>
  </div>

  <!-- ── Section activités ── -->
  <div class="section-hd">
    <span class="section-title">{{ 'mobileSimulator.dashboard.recentActivities' | translate }}</span>
  </div>

  <div class="actus-htl-wrap">
    <div class="actus-htl" #actusFeed
      (mousedown)="onActusMouseDown($event, actusFeed)"
      (mousemove)="onActusMouseMove($event, actusFeed)"
      (mouseup)="onActusMouseUp()"
      (mouseleave)="onActusMouseUp()">
      @for (a of actus.slice(0, 4); track a.id; let last = $last) {
        <div class="ahtl-item" [class.ahtl-item--last]="last">
          <div class="ahtl-top">
            <div class="ahtl-dot" [attr.data-type]="a.type"></div>
            @if (!last) { <div class="ahtl-line"></div> }
          </div>
          <div class="ahtl-body">
            <span class="ahtl-badge" [attr.data-type]="a.type">{{ a.badge }}</span>
            <p class="ahtl-msg">{{ a.message }}</p>
            <span class="ahtl-time">{{ timeOf(a.offsetMin) }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="link-row">
    <button class="link-btn" (click)="openActus.emit()">{{ 'mobileSimulator.common.tousVoir' | translate }}</button>
  </div>

  <!-- ── Grille 2 tuiles bas ── -->
  <div class="grid-2">
    <div class="grid-tile" (click)="openSatisfaction.emit()">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="#513E9B">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
      </svg>
      <span>{{ 'mobileSimulator.common.satisfaction' | translate }}</span>
    </div>
    <div class="grid-tile" (click)="openAvisPatient.emit()">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="#513E9B">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM12 15l-4.24-4.24 1.41-1.41L12 12.17l6.83-6.83 1.41 1.41z"/>
      </svg>
      <span>{{ 'mobileSimulator.common.avisPatients' | translate }}</span>
    </div>
  </div>

</div>